import { LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ProgressBar = styled(LinearProgress, {
  shouldForwardProp: prop => prop !== 'thickness',
})<{ thickness?: number }>(({ theme, thickness = 10 }) => ({
  height: thickness,
  borderRadius: theme.shape.borderRadius,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
  },
}));
